export type User = {
  firstName: string;
  lastName: string;
  email: string;
  password: string;
  phone: string;
  organization: string;
  company: string;
  siret: string;
  tva: string;
  function: string;
  persons: number;
  newsletter: boolean;
  role: UserRoles;
  id_step: number;
};

export type BaseUser = {
  id: number;
  firstName: string;
  lastName: string;
  email: string;
  password: string;
  phone: string;
  function: string;
  newsletter: boolean;
  id_step: number;
  role: UserRoles;
  created_at: Date;
};

export interface UserPUB extends BaseUser {
  id_entity: number;
  role: UserRoles.AcheteurPublic;
}

export interface UserENT extends BaseUser {
  id_referrer: number | null;
  id_company: number;
  logo?: string;
  id_plan: number;
  valid_until: Date;
  role: UserRoles.Entreprise;
}

export type UserDIR = {
  id: number;
  firstName: string;
  lastName: string;
  email: string;
  password: string;
  id_step: number;
  role: UserRoles.DirecteurCommercial;
  created_at: Date;
};

export enum UserRoles {
  AcheteurPublic = 'PUB',
  Entreprise = 'ENT',
  Commercial = 'COM',
  DirecteurCommercial = 'DIR',
}

export type SubUser = {
  id: number;
  id_user: number;
  firstName: string;
  lastName: string;
  email: string;
  password: string;
  rights: string;
  created_at: Date;
}
